import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { api, put, post, get } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import SelectFieldMachineType from "./SelectFields";
import formatTitleWithOptional from "../../OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function AddOffRoad({
  inputData,
  fetchData,
  id,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();
  const [errors, setErrors] = useState({});
  const [fuelType, setFuelType] = useState("");
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    machineryCategory: data?.machineryCategory || "",
    machineryType: data?.machineryType?._id || "",
    machineryName: data?.machineryName?._id || "",
    typeOfEntry: data?.typeOfEntry || "",
    uniqueIdOfEquipment: data?.uniqueIdOfEquipment || "",
    fuelType: data?.fuelType || "",
    fuelConsumed: {
      value: data?.fuelConsumed.value || "",
      unit: data?.fuelConsumed.unit || "",
    },
    usedhours: data?.usedhours || "",
    remarks: data?.remarks || "",
    documents: data?.documents || [],
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [uniqueId, setUniqueId] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState("");
  const resetForm = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setFuelType(data === null ? "" : data?.fuelType);
    setErrors({}); // Reset errors
    console.log("FromValue:", data);
  };

  const fetchFuelType = (value) => {
    console.log(formData.machineryName, "formDataMachineryName");
    get(`${api}/master/getByIDMachinery?_id=${value}`)
      .then((response) => {
        console.log(
          "responseForFuelType",
          response.data.data,
          response.data.data?.fuelType
        );
        setFuelType(response.data.data?.fuelType);
        setFormData((prevState) => ({
          ...prevState,
          fuelType: response.data.data?.fuelType,
          fuelConsumed: {
            ...prevState.fuelConsumed,
            unit:
              response.data.data?.fuelType === "Electricity"
                ? "KWH"
                : [
                    "Petrol (100% mineral petrol)",
                    "Diesel (100% mineral diesel)",
                  ].includes(response.data.data?.fuelType)
                ? "Liters"
                : [""],
          },
        }));
        response.data.data?.equipments.length >= 0 &&
          setUniqueId(response.data.data?.equipments);
      })
      .catch((err) => console.log("err", err));
  };

  const fetchMachineName = (value) => {
    get(`${api}/master/getByIDMachinery?_id=${value}`)
      .then((response) => {
        console.log(
          "responseForFuelType",
          response.data.data?.equipments.length,
          response.data.data?.fuelType
        );
        // setFuelType(response.data.data?.fuelType)
        // setFormData((prevState) => ({ ...prevState, fuelType: response.data.data?.fuelType }));
        // response.data.data?.equipments.length>=0  &&
        // setUniqueId(response.data.data?.equipments)
      })
      .catch((err) => console.log("err", err));
  };

  useEffect(() => {
    // if (addData) {
    //   setFormData(initialState); // Reset form data when opening the drawer
    // }
    console.log("UploadingData====:", data, id);
    if (id && data) {
      console.log("UploadingData:", data, id);
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles(data.documents || []);
      setFuelType(data?.fuelType || "");
      fetchFuelType(data?.machineryName?._id);
    } else if (!id) {
      setFormData(initialState);
      setFormData2(initialState);
      setFuelType("");
      setUploadedFiles([]);
    }
  }, [data, id]);

  //  useEffect(()=>{
  //   setFetchDataMachine(formData?.machineryCategory)
  //   // setFormData((prev)=>({
  //   //   ...prev,
  //   //   machineryType:""
  //   // }))
  //  },[formData?.machineryCategory])
  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    resetForm();
    setSelectedMonth(data?.monthYear?.month || "");
    setSelectedYear(data?.monthYear?.year || "");
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };

  const handleChange = (e) => {
    console.log("hii fr testing");
    const { name, value } = e.target;
    console.log("handleChangeForField", name, value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

    setFormData((prevState) => ({ ...prevState, [name]: value }));
    if (name === "machineryName") {
      console.log(value, "changedForMAchineName");
      fetchFuelType(value);
    }
    if (name === "machineryType") {
      fetchMachineName(value);
    }

    if (name.startsWith("fuelConsumed")) {
      const key = name.split(".")[1];
      setFormData((prevState) => ({
        ...prevState,
        fuelConsumed: {
          ...prevState.fuelConsumed,
          [key]: value,
        },
      }));
    }
  };

  const handleClose = () => {
    // const isFormDataUnchanged = Object.keys(formData).every(
    //   (key) => formData[key] === formData2[key]
    // );
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];

      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    console.log(
      isFormDataUnchanged,
      formData2,
      formData,
      "isFormDataUnchanged"
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      // setAddData(false);
      // setErrors({});
      setEditDialog(true);
      // resetForm();
      // Show the EditDialog if there are changes
    }
    // setFormData(initialState); // Reset form data to initial state
    // setUploadedFiles([]); // Reset uploaded files
  };

  const validateForm = () => {
    const newErrors = {};
    console.log(formData);

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (!validateNumber(month)) newErrors["month"] = "Month is required";

        if (!validateNumber(year)) newErrors["year"] = "Year is required";

        return;
      }
      if (input.fieldName === "fuelConsumed") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (!validateNumber(cvValue) || cvValue === "") {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value required.",
          };
        }

        if (cvUnit === "") {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }

      // Skip validation for hours and industrialEquipment if not in Individual mode
      if (
        formData.typeOfEntry === "Individual" &&
        input.fieldName === "uniqueIdOfEquipment" &&
        (!value || value.trim() === "Tap to select" || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
        return; // Skip validation for these fields
      }

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value) || value === "") {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
      //   console.log(input.fieldName,uploadedFiles)
      //    newErrors[input.fieldName] = `Please upload Documents`;
      //  }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (
        input.fieldName === "machineryType" &&
        formData?.machineryCategory !== "" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (
        input.fieldName === "machineryName" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    console.log(newErrors, formData?.machineryCategory, "new errors");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };
    delete dataToSend[`fuelConsumed.value`];

    // Conditionally delete fields if typeOfEntry is not "Individual"

    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hoursUsed;
      delete dataToSend.uniqueIdOfEquipment;
    }
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;
    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData({});
        handleClose();
        handleExitAgree();
        resetForm();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    console.log(
      "elForRenderInput",
      el.url,
      el.type,
      el.fieldName,
      formData[el.fieldName]
    );
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={"name"}
          keyName={"name"}
        />
      );
    }
    if (
      el.type === "uniqueIdOfEquipment" &&
      formData.typeOfEntry === "Individual"
    ) {
      const uniqueIds = uniqueId.map((item) => item.uniqueID);
      console.log("uniqueIds", uniqueIds);
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={uniqueIds}
          errors={errors[el.fieldName]}
          // url={el.url}
          // field={el.type}
        />
      );
    }

    if (el.type === "machineType") {
      return (
        <SelectFieldMachineType
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChangeMachine={handleChange}
          // options={el.options}
          // fetchMachineName={fetchMachineName}
          formData={formData}
          errors={errors[el.fieldName]}
          url={el.url}
          // field={el.type}
        />
      );
    }
    if (el.type === "machineryName") {
      return (
        <SelectFieldMachineType
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChangeMachine={handleChange}
          // options={el.options}
          // fetchMachineName={fetchMachineName}
          formData={formData}
          errors={errors[el.fieldName]}
          url={el.url}
          // field={el.type}
        />
      );
    }
    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "fuelType")
      return (
        <InputField
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={fuelType || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
          disabled={true}
        />
      );

    if (el.fieldName === "fuelConsumed") {
      return (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
            {el.title}
          </Typography>
          {/* <Box sx={{ display: "flex", gap: "10px", width: "100%" }}> */}
          <Box sx={{ width: "100%" }}>
            <InputField
              // title={el.title}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData[el.fieldName]?.value}
              errors={errors[el.fieldName]?.value}
              fieldName={"fuelConsumed.value"}
              adornmentText={
                formData?.fuelType === "Electricity"
                  ? ["KWH"]
                  : [
                      "Petrol (100% mineral petrol)",
                      "Diesel (100% mineral diesel)",
                    ].includes(formData?.fuelType)
                  ? ["Liters"]
                  : ["Unit"]
              }
            />
          </Box>
          {/* <Box sx={{ width: "30%" }}>
            <SelectField
              // title={el.title}
              name={"fuelConsumed.unit"}
              value={formData[el.fieldName]?.unit}
              handleChange={handleChange}
              options={
                formData?.fuelType === "Electricity" ? ["KWH"] : ["Liters"]
              }
              errors={errors[el.fieldName]?.unit}
              url={el.url}
              field={"name"}
              keyName={"name"}
            />
          </Box> */}
        </Box>
        // </Box>
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={el.title}
            {...{
              // setSelectedMonth,
              // setSelectedYear,
              // selectedMonth,
              // selectedYear,
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: data?.monthYear?.month || "",
              // defaultYear: data?.monthYear?.year || "",
            }}
          />
        </Box>
      );
    }
    if (el.fieldName === "fuelType")
      return (
        <InputField
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={fuelType || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id
            ? "Edit Off Road Vehicle and Equipment"
            : "Add Off Road Vehicle and Equipment"}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hoursUsed" ||
              el.fieldName === "uniqueIdOfEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddOffRoad;
